import { Navigate, Outlet } from 'react-router-dom';
import { useOutletContext } from 'react-router-dom';
import routes from '../../utils/routes';
import { RouterOutletContext } from '../router';

const PublicOnlyWrapper = () => {
    const context = useOutletContext<RouterOutletContext>();

    if (context.userProfile) {
        return <Navigate to={routes.orders.list} replace />;
    }

    return <Outlet context={context} />;
};

export default PublicOnlyWrapper;
